export const sustainability = {
  // -----
  section01: {
    title: "Sustainability",
    content: [
      "As a company, we strongly value sustainability as a core business principle in everything we do.",
      "Soho Blinds’ commitment to sustainability is demonstrated in our everyday activity both with our monitored carbon footprint reduction and in promoting sustainable products to the construction industry. Below are some of the ways in which Soho Blinds contributes towards making this world a better place.",
      "Soho Blinds constantly strive to operate on a sustainable basis in all aspects of business activity. For more information please download a copy of our Environmental Policy below.",
    ]
  },
};
